<template>
  <v-snackbar
    v-model="generalMessageSBIn"
    top
    absolute
    auto-height
    :timeout="timeout"
    :color="generalMessageInfoSB.type"
  >
    {{ generalMessageInfoSB.message }}
    <v-btn class="text-capitalize" color="white" flat @click="close">
      Cerrar
      <font-awesome-icon
        class="ml-2"
        :style="{ color: '#FFFFFF' }"
        size="lg"
        :icon="['fal', 'times-circle']"
      />
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      timeout: 0
    };
  },
  computed: {
    ...mapGetters(["generalMessageSB", "generalMessageInfoSB"]),
    generalMessageSBIn: {
      get() {
        return this.generalMessageSB;
      },
      set(value) {
        this.$store.commit("SET_GENERAL_MESSAGE_SHOW_SB", value);
      }
    }
  },
  methods: {
    close() {
      this.$store.commit("SET_GENERAL_MESSAGE_SHOW_SB", false);
    }
  }
};
</script>
